import React, { useEffect, useRef } from 'react';
import './About.css';

const About = () => {
  const sections = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px',
      }
    );

    sections.current.forEach((section) => {
      if (section) {
        observer.observe(section);
      }
    });

    return () => {
      sections.current.forEach((section) => {
        if (section) {
          observer.unobserve(section);
        }
      });
    };
  }, []);

  const addToRefs = (el) => {
    if (el && !sections.current.includes(el)) {
      sections.current.push(el);
    }
  };

  return (
    <div className="about-container">
      <section ref={addToRefs} className="mission-section">
        <h2>Our Mission</h2>
        <p>
          To strengthen the child-welfare ecosystem by equipping non-profits with the marketing and sales tools they need to thrive. 
          Our impact is measured by the success of our partners in delivering crucial safety and education services to children.
        </p>
      </section>

      <section ref={addToRefs} className="vision-section">
        <h2>Our Vision</h2>
        <p>
          To see a collaborative and resilient non-profit sector where every organization dedicated to children is financially secure, 
          widely recognized, and achieving its maximum impact.
        </p>
      </section>

      <section ref={addToRefs} className="story-section">
        <h2>Our Story</h2>
        <p>
          Founded in 2023, Niaarav emerged from a shared vision of creating meaningful impact
          in our communities. Our journey began with a simple idea: to combine technology and
          social innovation to address pressing challenges.
        </p>
        <div className="timeline">
          <div className="timeline-item">
            <h4>2023</h4>
            <p>Niaarav was founded with a vision to create sustainable impact</p>
          </div>
          <div className="timeline-item">
            <h4>2024</h4>
            <p>Launched our first community development initiative</p>
          </div>
          <div className="timeline-item">
            <h4>Present</h4>
            <p>Expanding our reach and impact through innovative programs</p>
          </div>
        </div>
      </section>

      <section ref={addToRefs} className="impact-section">
        <h2>Our Impact</h2>
        <div className="impact-stats">
          <div className="stat-item">
            <h3>Communities Served</h3>
            <p>10+</p>
          </div>
          <div className="stat-item">
            <h3>Projects Completed</h3>
            <p>15+</p>
          </div>
          <div className="stat-item">
            <h3>Lives Impacted</h3>
            <p>1000+</p>
          </div>
        </div>
        <div className="impact-stories">
          <h3>Success Stories</h3>
          <div className="story-grid">
            <div className="story-card">
              <h4>Community Education</h4>
              <p>Empowering youth through digital literacy programs</p>
            </div>
            <div className="story-card">
              <h4>Environmental Initiative</h4>
              <p>Creating sustainable solutions for local communities</p>
            </div>
            <div className="story-card">
              <h4>Healthcare Access</h4>
              <p>Improving healthcare accessibility in rural areas</p>
            </div>
          </div>
        </div>
      </section>

      <section ref={addToRefs} className="team-section">
        <h2>Our Team</h2>
        <p>
          Our diverse team brings together expertise from various fields, united by a common
          passion for creating positive change. We believe in the power of collaboration and
          innovation to drive sustainable impact.
        </p>
        <div className="team-grid">
          <div className="team-member">
            <h4>Leadership</h4>
            <p>Experienced professionals guiding our vision and strategy</p>
          </div>
          <div className="team-member">
            <h4>Program Team</h4>
            <p>Dedicated individuals implementing our initiatives</p>
          </div>
          <div className="team-member">
            <h4>Support Staff</h4>
            <p>Essential team members ensuring smooth operations</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About; 